<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import BuzzInsightMetricRow from './BuzzInsightMetricRow.vue';

const props = defineProps({
  media: {
    type: Object,
    default: () => ({}),
  },
});

const { t } = useI18n();

const metrics = computed(() => {
  const items = [];
  if (props.media?.total_mention_count_7d != null) {
    items.push({
      key: 'mentions',
      label: t('BUZZ_REPORTS.INSIGHTS.MENTIONS_7D'),
      value: String(props.media.total_mention_count_7d),
      infoText: t('BUZZ_REPORTS.INSIGHTS.MENTIONS_7D'),
    });
  }
  if (props.media?.news_count_7d != null) {
    items.push({
      key: 'news',
      label: t('BUZZ_REPORTS.INSIGHTS.NEWS_7D'),
      value: String(props.media.news_count_7d),
      infoText: t('BUZZ_REPORTS.INSIGHTS.NEWS_7D'),
    });
  }
  if (props.media?.directory_hits != null) {
    items.push({
      key: 'directories',
      label: t('BUZZ_REPORTS.INSIGHTS.DIRECTORY_HITS'),
      value: String(props.media.directory_hits),
      infoText: t('BUZZ_REPORTS.INSIGHTS.DIRECTORIES_TITLE'),
    });
  }
  if (props.media?.social_mention_count_7d != null) {
    items.push({
      key: 'social_mentions',
      label: t('BUZZ_REPORTS.INSIGHTS.SOCIAL_MENTIONS_7D'),
      value: String(props.media.social_mention_count_7d),
      infoText: t('BUZZ_REPORTS.INSIGHTS.SOCIAL_MENTIONS_7D'),
    });
  }
  if (props.media?.social_post_count != null) {
    items.push({
      key: 'social',
      label: t('BUZZ_REPORTS.INSIGHTS.SOCIAL_POSTS'),
      value: String(props.media.social_post_count),
      infoText: t('BUZZ_REPORTS.INSIGHTS.SOCIAL_POSTS'),
    });
  }
  return items;
});
</script>

<template>
  <BuzzInsightMetricRow
    :metrics="metrics"
    :empty-label="t('BUZZ_REPORTS.INSIGHTS.NO_MEDIA')"
  />
</template>
